module.exports = __webpack_public_path__ + "img/123.7f507144.jpg";